module.exports = __webpack_public_path__ + "091dce3913df06cc06aaa220f7ee3a3f.png";